import React, { useState } from 'react';
import { CheckIcon } from "lucide-react";
import ConfirmDialog from '../ConfirmDialog';

const Button = ({ buttonConfig, onClick, disabled = false }) => {
  const { name, value, action, action_type, button_otp } = buttonConfig;
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subtitle: "",
  });  

  const getIcon = (actionType) => {
    switch (actionType.toLowerCase()) {
      case 'approve':
        return <CheckIcon className="w-4 h-4" />;
      case 'reject':
        return (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        );
      case 'update':
        return (
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
        );
      default:
        return null;
    }
  };

  // Style mapping based on action_type
  const getButtonStyles = (actionType) => {
    const baseStyles = "px-4 py-2 rounded-md flex items-center gap-2 transition-colors text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2";
     
    switch (actionType.toLowerCase()) {
      case 'approve':
        return `${baseStyles} bg-primary hover:bg-red-700 text-white focus:ring-red-500`;
      case 'reject':
        return `${baseStyles} border border-primary text-red-600 hover:bg-red-50 focus:ring-red-500`;
      default:
        return `${baseStyles} bg-gray-600 hover:bg-gray-700 text-white focus:ring-gray-500`;
    }
  };

  const handleClick = () => {
    if (disabled) return;
    
    // Handle OTP requirement if needed
    if (button_otp === 'Yes') {
      // You can implement OTP modal logic here
      console.log('OTP required for:', name);
    }

    setConfirmDialog({
      isOpen: true,
      title: "Are you sure you want to proceed?",
      subtitle: "You can't undo this operation",
      onConfirm: () => {
        onClick?.(buttonConfig);
      },
    })
  };

  return (
    <>
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`${getButtonStyles(action_type)} ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      title={`${name} - ${action_type}`}
      data-action={action}
      data-action-type={action_type}
      data-value={value}
    >
      {name}
      {getIcon(action_type)}
    </button>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </>
  );
};

const ActionButtons = ({ 
  buttons = [], 
  onButtonClick, 
  disabled = false, 
  className = "" 
}) => {
  const handleButtonClick = (buttonConfig) => {
    console.log('Button clicked:', buttonConfig);
    
    onButtonClick?.(buttonConfig);
  };

  if (!buttons || buttons.length === 0) {
    return null;
  }

  return (
    <div className={`flex gap-3 ${className}`}>
      {buttons.map((buttonConfig, index) => (
        <Button
          key={`${buttonConfig.action_type}-${index}`}
          buttonConfig={buttonConfig}
          onClick={handleButtonClick}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default ActionButtons;
export { Button };